import { useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import CarouselSevices, { servicesTravel } from '../../share/components/CarouselServices/CarouselSevices'
import './styles.css'
import GalleryImg from './GalleryImg/GalleryImg'
import ServicesInclude from './ServicesInclude/ServicesInclude'

const DetailHotel = () => {

  const [slideShow, setSlideShow] = useState(false)

  const {
    dataHab,
    dataHot
  }
    = useLocation().state

  function formatterText(frase) {
    // Dividir la frase en palabras individuales
    let palabras = frase.toLowerCase().split(' ');

    // Capitalizar la primera letra de cada palabra
    for (let i = 0; i < palabras.length; i++) {
      palabras[i] = palabras[i].charAt(0).toUpperCase() + palabras[i].slice(1);
    }

    // Unir las palabras en una sola frase
    let resultado = palabras.join(' ');

    return resultado;
  }


  return (
    <div>
      <CarouselSevices current={servicesTravel[1]?.title} />
      <div className='detail-hotel-route'>
        <p>
          <Link to={'/hotel'}>Hoteles</Link> {">"} Buscador {">"} <span >{dataHot?.nombre_h}</span>
        </p>
      </div>
      <div className='contain-title-hotel'>
        <h1>
          {dataHot?.nombre_h}
        </h1>
        <p>{dataHot?.provincia} {formatterText(dataHab.dir)}</p>
      </div>
      <div className='contain-img-principal-hotel'>
        <section className='section-img-big'>
          <img src={dataHot?.fotos?.foto[0]} alt="" />
          <span onClick={() => { setSlideShow(!slideShow) }}>Ver Fotos</span>
        </section>
        <section className='section-img-layout-for'>
          <img src={dataHot?.fotos?.foto[1]} alt="" />
          <img src={dataHot?.fotos?.foto[2]} alt="" />
          <img src={dataHot?.fotos?.foto[3]} alt="" />
          <img src={dataHot?.fotos?.foto[4]} alt="" />
        </section>
      </div>
      {
        slideShow &&
        <GalleryImg Images={dataHot?.fotos?.foto} setSlideShow={setSlideShow} />
      }
      <ServicesInclude serviciosHot={dataHot?.servicios?.servicio} serviciosHab={dataHot?.servicios_habitacion?.servicio_habitacion} checkin={dataHot?.checkin} checkout={dataHot?.checkout} star={dataHot?.categoria}/>


    </div>
  )
}

export default DetailHotel